import Header from './components/Header';
import Hero from './components/Hero';
import AppSection from './components/AppSection';
import ContactSection from './components/ContactSection';
import CarouselSection from './components/CarouselSection';
import AboutSection from './components/AboutSection';
import CommentsSection from './components/CommentsSection';
import FeaturesSection from './components/FeaturesSection';
import MediaSection from './components/MediaSection';
import TopicsSection from './components/TopicsSection';
import CardsSection from './components/CardsSection';
import UpdatesSection from './components/UpdatesSection';
import RankingSection from './components/RankingSection';
import IndexSection from './components/IndexSection';
import FaqSection from './components/FaqSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <Hero />
        <AppSection />
        <ContactSection />
        <CarouselSection />
        <AboutSection />
        <CommentsSection />
        <FeaturesSection />
        <MediaSection />
        <TopicsSection />
        <CardsSection />
        <UpdatesSection />
        <RankingSection />
        <IndexSection />
        <FaqSection />
      </main>
      <Footer />
    </div>
  );
}